<template>
  <div>
    <!-- <div>markerModel: {{ markerModel }}</div> -->
    <leaflet-map ref="map" 
      :id="id" @rightclick="mapRightClick">
      <leaflet-searchbar ref="search" @onSearch="onSearch" :searchQuery="markerModel.fullAddress"></leaflet-searchbar>
      <leaflet-marker
        v-if="markerModel"
        :latitude="markerModel.latitude"
        :longitude="markerModel.longitude"
      />
    </leaflet-map>
  </div>
</template>

<script>
import WaypointResequenceMixin from "@/mixins/tripPlan/WaypointResequenceMixin.js";

export default {
  name: "LeafletMarkerCrud",
  components: {
    LeafletMap: () => import("@/components_rms/base/leaflet/LeafletMap.vue"),
    LeafletMarker: () =>
      import("@/components_rms/base/leaflet/LeafletMarker.vue"),
    LeafletSearchbar: () =>
      import("@/components_rms/base/leaflet/LeafletSearchbar.vue"),
  },
  mixins: [WaypointResequenceMixin],
  props: {
    model: Object,
    id: String,
  },
  data() {
    return {};
  },
  computed: {
    markerModel: {
      get: function () {
        return this.model;
      },
      set: function (newValue) {
        this.$emit("update:model", newValue);
      },
    },
  },
  methods: {
    mapRightClick(e) {
      console.log("mapRightClick");
      console.log(e);
      console.log(e.latlng);
      this.markerModel = {
        latitude: e.latlng.lat,
        longitude: e.latlng.lng,
        fullAddress: this.model.fullAddress,
      };
      // this.$refs.search.searchAddressByLatLng(e.latlng.lat, e.latlng.lng)
    },
    onSearch(searchResult) {
      this.markerModel = searchResult;
    },
  },
  watch: {
    model() {
      if (!this.model) return;
      this.$refs.map.fitBounds([[this.model.latitude, this.model.longitude]]);
    },
  },
};
</script>
  <style scoped>
.imageMap {
  width: 25% !important;
}
</style>